<template>
    <el-dialog
    :title="(operation=='add'?'发布':'编辑')+'课程任务'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    width="120rem">
    <div class="dia-box">
        <div class="item">
            <p>任务名称</p>
            <el-input v-model="form.taskName" placeholder="请输入任务名称"></el-input>
        </div>
        <div class="item" style="margin-top: 3rem;">
            <p>任务内容</p>
            <el-input v-model="form.taskContent" placeholder="请输入任务内容"></el-input>
        </div>
        <div class="item" style="margin-top: 3rem;">
            <p>关联班级</p>
            <el-select v-model="form.classIds" multiple placeholder="请选择关联班级">
                <el-option
                v-for="item in classList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="relate-box">
            <p>关联课程</p>
            <div class="table-content-box">
                <div class="top-box">
                    <div class="category-box">
                        <div v-for="(item,index) in Category" @click="changeCategory(item)" :class="{'category-active':item.value==currentCategory}" :key="index">{{ item.label }}</div>
                    </div>
                    <div class="input-box">
                        <p>搜索</p>
                        <el-input v-model="keywords" style="width: 20rem;" @keydown.enter.native="search" clearable @clear="search" placeholder="请输入名称">
                            <template slot="prefix">
                                <div class="search-ipt-box">
                                    <img style="cursor: pointer;width: 16px;height: auto;" src="../../../assets/image/magSys/search.png" @click="search" alt="">
                                </div>
                            </template>
                        </el-input>
                    </div>
                </div>
                <div class="content-box" v-infinite-scroll="loadCourse">
                    <div v-for="(item,index) in courseList" :class="{'active-border':isChecked(item.id)}" class="soft-item" @click="addCourse(item)" :key="index">
                        <div class="no-start-label" :style="`background-color:${filterStatus(item.courseStatus)};`">{{ item.courseStatus }}</div>
                        <img :src="item.coverImageUrl?$severUrl(item.coverImageUrl):$filterResDefault(item.classifyCode)" alt="">
                        <div :class="{'active-color':isChecked(item.id)}" class="btm-box">
                            <div class="course-time-label">{{item.creditHour||0}}课时</div>
                            <el-tooltip effect="dark" :disabled="item.courseName.length<=7" :content="item.courseName" placement="top-start">
                                <p class="overflow">{{ item.courseName }}</p>
                            </el-tooltip>
                        </div>
                    </div>
                    <no-data v-if="courseList.length==0"></no-data>
                </div>
            </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <div class="cancel-btn" @click="handleClose">取消</div>
        <div class="save-btn" v-debounce="saveTask">保存</div>
    </div>
    </el-dialog>
</template>
<script>
import { Category,filterStatus } from '@/utils/utils';
import { GetClassList } from '@/api/class';
import { AddCourseTask,UpdateCourseTask } from '@/api/courseTask';
import { PageQueryPermissionList } from '@/api/course';
import NoData from '../../common/NoData.vue';
    export default {
  components: { NoData },
        data(){
            return {
                Category:[{label:'全部',value:''},...Category],
                dialogVisible:false,
                /**仿真软件默认图片 */
                virtual:require('../../../assets/image/resource/virtual.png'),
                form:{
                    taskName:'',
                    taskContent:'',
                    classIds:[],
                    courseIds:[]
                },
                operation:'',
                /**班级列表 */
                classList:[],
                taskId:'',
                /**软件搜索关键字 */
                keywords:'',
                /**当前所属分类 */
                currentCategory:'',
                courseList:[],
                pages:{
                    current:1,
                    size:10,
                    total:0
                }
            }
        },
        methods:{
            filterStatus,
            /**搜索课程 */
            search(){
                this.pages.current=1;
                this.pageQueryPermissionList();
            },
            changeCategory(item){
                this.currentCategory=item.value;
                this.search();
            },
            /**添加课程 */
            addCourse(item){
                if(this.isChecked(item.id)){
                    let index=this.form.courseIds.findIndex(e=>e==item.id);
                    index!=-1&&this.form.courseIds.splice(index,1);
                }else{
                    this.form.courseIds.push(item.id);
                }
            },
            /**下拉加载课程 */
            loadCourse(){
                let total=this.pages.current*this.pages.size;
                if(total>=this.pages.total)return;
                this.pages.current++;
                this.pageQueryPermissionList();
            },
            /**新增课程任务 */
            addCourseTask(){
                AddCourseTask(this.form).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "新增课程任务成功",
                            type: "success",
                        });
                        this.handleClose();
                        this.$emit('create_success');
                    }
                })
            },
            /**查询拥有权限的课程 */
            pageQueryPermissionList(){
                let params={
                "classifyCode": this.currentCategory,
                "courseName": this.keywords,
                "current": this.pages.current,
                "size": this.pages.size
                }
                PageQueryPermissionList(params).then(res=>{
                    if(res.code==200){
                        if(this.pages.current==1){
                            this.courseList=res.data.records;
                        }else{
                            this.courseList=[...this.courseList,...res.data.records];
                        }
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**修改课程任务 */
            updateCourseTask(){
                this.form.id=this.taskId;
                UpdateCourseTask(this.form).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "修改课程任务成功",
                            type: "success",
                        });
                        this.handleClose();
                        this.$emit('create_success');
                    }
                })
            },
            /**初始化表单 */
            handleClose(){
                this.form={
                    taskName:'',
                    taskContent:'',
                    classIds:[],
                    courseIds:[]
                };
                this.currentCategory='';
                this.dialogVisible=false;
            },
            /**判断软件是否已选中 */
            isChecked(id){
                let el=this.form.courseIds.find(item=>id==item);
                if(el){
                  return true;
                }else{
                  return false;
                }
            },
            /**分页查询班级信息 */
            getClassList(){
                let params={
                "classCode": "",
                "className": "",
                }
                GetClassList(params).then(res=>{
                    if(res.code==200){
                        this.classList=res.data.map(item=>{
                            return {
                                label:item.className,
                                value:item.id
                            }
                        });
                    }
                })
            },
            /**新增实训任务 */
            saveTask(){
                if(this.form.courseIds.length==0){
                    this.$msg({
                            showClose: true,
                            message: "请关联课程",
                            type: "warning",
                        });
                    return;
                }
              if(this.operation=='add'){
                this.addCourseTask();
              }else{
                this.updateCourseTask();
              }
            },
        },
        mounted(){
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
.item{
    &> :nth-child(2){
        margin-top: 16px;
    }
}
.cancel-btn{
    width: 8.8rem;
    height: 4rem;
    background: rgba(56,125,255,0.00);
    border: 1px solid #e8ecef;
    border-radius: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.save-btn{
    width: 8.8rem;
    height: 4rem;
    background: var(--blue);
    border: 1px solid #e8ecef;
    border-radius: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    margin-left: 3.5rem;
    cursor: pointer;
}
.dialog-footer{
    display: flex;
    justify-content: center;
}
.item-box{
    display: flex;
    margin-top: 3rem;
}
.element-box{
    &> :nth-child(2){
        margin-top: 16px;
    }
}
.dia-box{
    color: #334681;
    height: 80rem;
}
.relate-box{
    margin-top: 3rem;
}
.table-content-box{
    height: 43rem;
    border: 1px solid #e8ecef;
    margin-top: 16px;
}
.top-box{
    border-bottom: 1px solid #e8ecef;
    font-size: 16px;
    color: #334681;
    padding: 0 2.4rem 0;
    justify-content: space-between;
    align-items: center;
    display: flex;
    .category-box{
        display: flex;
        &> :nth-child(n){
        margin-left: 4.8rem;
        cursor: pointer;
        height: 100%;
        padding: 2.5rem 0;
        border-bottom: 0.4rem solid transparent;
        transition: all 0.3s;
        }
        &> :nth-child(1){
            margin-left: 0;
        }
    }
    .input-box{
        display: flex;
        align-items: center;
        &> :nth-child(1){
            margin-right: 1rem;
            cursor: pointer;
        }
    }
}
.input-box{
/deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
    padding-left: 3.5rem;
}
.search-ipt-box{
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}
}
.category-active{
    border-bottom: 0.4rem solid var(--blue) !important;
}
.content-box{
    height: calc(100% - 7rem);
    overflow: auto;
    padding: 2rem;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    &> :nth-child(n){
        margin-left: 1.5rem;
        cursor: pointer;
    }
    &> :nth-child(5n+1){
        margin-left: 0;
    }
    &> :nth-child(n+6){
            margin-top: 1.5rem;
        }
}
.soft-item{
    width: calc((100% - 6rem)/5);
    border: 1px solid #e0e8f2;
    position: relative;
    img{
        width: 100%;
        aspect-ratio: var(--aspectRatio);
        object-fit: cover;
    }
    &> :nth-child(3){
        padding: 1rem 1.7rem;
        font-size: 14px;
        color: #151C34;
        font-weight: 700;
    }
}
.active-border{
    border: 2px solid var(--blue) !important;
}
.active-color{
    color: var(--blue) !important;
}
.no-start-label{
    padding: 0.7rem 1rem;
    height: 2.4rem;
    color: #ffffff;
    border-radius: 0 0px 1rem 0px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.course-time-label{
    background: linear-gradient(0deg,#72bbff 0%, #387dff 100%);
    border-radius: 0.8rem 0px 0px 0px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    padding: 0.2rem 0.5rem;
}
.btm-box{
    display: flex;
    align-items: center;
    &> :nth-child(2){
        margin-left: 1rem;
        flex: 1;
    }
}
</style>